import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-title" }
const _hoisted_2 = { class: "mx-0 symbol symbol-circle symbol-35px me-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "text-primary fa fs-4 fa-arrow-left",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "text-primary bi bi-list-stars fs-3" })
  ])
], -1)
const _hoisted_5 = { class: "d-flex justify-content-center flex-column mx-3" }
const _hoisted_6 = {
  class: "text-gray-900 text-hover-primary",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#createGroup",
  "aria-expanded": "false",
  "aria-controls": "createGroup"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-0 lh-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-8 fw-bold text-muted" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        to: { name: 'sections' },
        target: "self",
        class: "symbol-label border border-primary border-dashed"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.formSection?.name), 1),
      _hoisted_7
    ])
  ]))
}